export enum SearchFiltersOptionTypesEnum {
  TYPE_SUBJECT_KNM = 'TYPE_SUBJECT_KNM',
  TYPE_KNM = 'TYPE_KNM',
  YEAR_KNM = 'YEAR_KNM',
  TYPE_OF_STATE_SUPERVISION = 'TYPE_OF_STATE_SUPERVISION',
  MONTH_KNM = 'MONTH_KNM',
  STATUS_KNM = 'STATUS_KNM',
}
